/**
 * 浏览器安全相关工具函数
 * 主要用于处理浏览器自动保存密码等安全问题
 */

/**
 * 清除浏览器保存的密码数据
 * 通过多种方式阻止浏览器保存和自动填充密码
 */
export const clearBrowserPasswordData = () => {
  try {
    // 查找页面中的所有密码输入框并清空
    const passwordInputs = document.querySelectorAll('input[type="password"]')
    passwordInputs.forEach(input => {
      input.value = ''
      input.setAttribute('autocomplete', 'new-password')
      // 触发input事件，确保Vue响应式数据也被清除
      input.dispatchEvent(new Event('input', { bubbles: true }))
    })
    
    // 查找用户名输入框并清空
    const usernameInputs = document.querySelectorAll('input[type="text"], input[type="email"]')
    usernameInputs.forEach(input => {
      if (input.name === 'username' || 
          input.placeholder?.includes('用户名') || 
          input.placeholder?.includes('账号') ||
          input.id?.includes('username') ||
          input.className?.includes('username')) {
        input.value = ''
        input.setAttribute('autocomplete', 'off')
        // 触发input事件，确保Vue响应式数据也被清除
        input.dispatchEvent(new Event('input', { bubbles: true }))
      }
    })
    
    // 创建一个隐藏的表单来"欺骗"浏览器，让它认为密码已经被清除
    const dummyForm = document.createElement('form')
    dummyForm.style.display = 'none'
    dummyForm.innerHTML = `
      <input type="text" name="username" value="" autocomplete="username" />
      <input type="password" name="password" value="" autocomplete="current-password" />
    `
    document.body.appendChild(dummyForm)
    
    // 短暂延迟后移除虚拟表单
    setTimeout(() => {
      if (dummyForm.parentNode) {
        dummyForm.parentNode.removeChild(dummyForm)
      }
    }, 100)
    
  } catch (error) {
    console.warn('清除浏览器密码数据时出错:', error)
  }
}

/**
 * 设置输入框的安全属性，防止浏览器自动填充
 * @param {HTMLElement} element - 输入框元素
 * @param {string} type - 输入框类型 ('username' | 'password')
 */
export const setSecureInputAttributes = (element, type) => {
  if (!element) return
  
  try {
    if (type === 'username') {
      element.setAttribute('autocomplete', 'off')
      element.setAttribute('spellcheck', 'false')
    } else if (type === 'password') {
      element.setAttribute('autocomplete', 'new-password')
      element.setAttribute('spellcheck', 'false')
    }
  } catch (error) {
    console.warn('设置安全输入框属性时出错:', error)
  }
}

/**
 * 在页面卸载时清除敏感数据
 */
export const clearSensitiveDataOnUnload = () => {
  const handleBeforeUnload = () => {
    clearBrowserPasswordData()
  }
  
  window.addEventListener('beforeunload', handleBeforeUnload)
  
  // 返回清理函数
  return () => {
    window.removeEventListener('beforeunload', handleBeforeUnload)
  }
}

/**
 * 禁用浏览器的密码保存提示
 */
export const disablePasswordSaving = () => {
  try {
    // 在表单提交时阻止浏览器保存密码
    const forms = document.querySelectorAll('form')
    forms.forEach(form => {
      form.setAttribute('autocomplete', 'off')
      
      // 监听表单提交事件
      form.addEventListener('submit', (e) => {
        // 在提交前短暂清除密码字段
        setTimeout(() => {
          const passwordInputs = form.querySelectorAll('input[type="password"]')
          passwordInputs.forEach(input => {
            const originalValue = input.value
            input.value = ''
            // 立即恢复值以确保提交正常进行
            setTimeout(() => {
              input.value = originalValue
            }, 10)
          })
        }, 50)
      })
    })
  } catch (error) {
    console.warn('禁用密码保存时出错:', error)
  }
}

export default {
  clearBrowserPasswordData,
  setSecureInputAttributes,
  clearSensitiveDataOnUnload,
  disablePasswordSaving
}